import api from './api';
import { IFinanceiroTituloReceber } from '../common/interfaces/faturamento.interfaces';
import { IGerarBoleto } from '../common/interfaces/gerarboleto.interfaces';

export function obterTitulos(): Promise<IFinanceiroTituloReceber[]> {
    return api.get('/faturamento/titulos-receber').then(res => res.data);
}

export function gerarBoleto(gerarBoleto: IGerarBoleto): Promise<any> {
    return api.post(`/faturamento/gerar-boleto`, gerarBoleto, { responseType: 'blob' }).then(res => res.data);
}

export function xmlNotaFiscal(idNotaFiscal: number): Promise<any> {
    return api.get(`/faturamento/download-xml-notafiscal/${idNotaFiscal}`,{ responseType: 'blob' }).then(res => res.data);
}

export function pdfNotaFiscal(idNotaFiscal: number): Promise<any> {
    return api.get(`/faturamento/download-pdf-notafiscal/${idNotaFiscal}`,{ responseType: 'blob' }).then(res => res.data);
}